/* template */
<template><page><base-container :class='["cascade-picker-page","_56420ea6","mpx-app-scope"]'><cascade-picker-basic :class='["","_56420ea6","mpx-app-scope"]'/><div :class='["cascade-picker-divider-wrapper","_56420ea6","mpx-app-scope"]'><cube-divider :class='["","_56420ea6","mpx-app-scope"]'/></div><cube-async-cascade-picker :class='["","_56420ea6","mpx-app-scope"]'/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_56420ea6"}'>
.cascade-picker-divider-wrapper
  margin 10px 0
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_56420ea6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_56420ea6"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_56420ea6"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cascade-picker-basic':getComponent(require("./cascade-picker-basic.mpx?isComponent&outputPath=components%2Fcascade-picker-basic0c588c4a%2Findex")),'cube-async-cascade-picker':getComponent(require("./async-picker.mpx?isComponent&outputPath=components%2Fasync-picker6c8adeb2%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>